module.exports = __webpack_public_path__ + "img/customer-industry-problem-icon2.2949d9e4.png";